<template>
  <div class="asc-alert-icon--container">
    <div
      v-if="isUp || isDown || isSquare || isCircle"
      class="asc-alert-icon--single"
    >
      <asc-icon
        v-if="isDown || isUpDown"
        icon="triangleDown"
        :color="getBgColor"
      ></asc-icon>
      <asc-icon
        v-if="isUp || isUpDown"
        icon="triangleUp"
        :color="getBgColor"
      ></asc-icon>
      <asc-icon
        v-if="isSquare"
        class="asc-alert-icon--top-padding"
        icon="square"
        :color="getBgColor"
      ></asc-icon>
      <asc-icon
        v-if="isCircle"
        class="asc-alert-icon--top-padding"
        icon="circle"
        :color="getBgColor"
      ></asc-icon>
    </div>
    <div v-if="isUpDown" class="asc-alert-icon--double">
      <asc-icon icon="triangleDown" :color="getBgColor"></asc-icon>
      <asc-icon icon="triangleUp" :color="getBgColor"></asc-icon>
    </div>
  </div>
</template>

<script>
import { AscStatusPropsMixin } from '@/components/mixins'
import AscIcon from './AscIcon'

export default {
  name: 'AscAlertIcon',

  components: {
    AscIcon,
  },

  mixins: [AscStatusPropsMixin],

  data() {
    return {
      upsideDownClass: 'upside-down',
    }
  },
}
</script>

<style lang="scss">
.asc-alert-icon--container {
  .asc-alert-icon--single {
    padding-right: 4px;

    .v-icon {
      margin-bottom: 2px;
    }

    .asc-alert-icon--top-padding {
      padding-top: 7px;
    }
  }

  .asc-alert-icon--double {
    display: flex;
  }
}
</style>
